import {
  Component,
  inject,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
} from "@angular/core";
import { AppConfig } from "../../app.config";
import { ConnectionService } from "@services/connection-service";
import { UserService } from "@services/user";

@Component({
  selector: "regimen-concern-selection",
  templateUrl: "./regimen-concern-selection.html",
  standalone: false,
})
export class RegimenConcernSelectionComponent implements OnInit {
  public readonly appConfig: AppConfig = inject(AppConfig);
  private readonly conn: ConnectionService = inject(ConnectionService);
  private readonly userService: UserService = inject(UserService);

  private static readonly DRAVIDIAN_CONCERN_TEXT_FONT_SIZE_PX = 15;
  private static readonly DEFAULT_CONCERN_TEXT_FONT_SIZE_PX = 20;

  get isDravidianScriptUser(): boolean {
    return this.userService.dravidianScripts.includes(
      this.conn.getActingUser()?.get("languagePreference"),
    );
  }

  get concernTextFontSize(): number {
    return this.isDravidianScriptUser
      ? RegimenConcernSelectionComponent.DRAVIDIAN_CONCERN_TEXT_FONT_SIZE_PX
      : RegimenConcernSelectionComponent.DEFAULT_CONCERN_TEXT_FONT_SIZE_PX;
  }

  get showHairFirst(): boolean {
    return this.gender() === this.appConfig.Shared.Gender.MALE;
  }

  concernClass: InputSignal<any> = input();
  gender: InputSignal<string> = input("female");

  selectConcern: OutputEmitterRef<string> = output();

  faceIconUrl: string;
  hairIconUrl: string;

  ngOnInit(): void {
    this.setIconUrls();
  }

  onSelectConcern(concernClass: string): void {
    this.selectConcern.emit(concernClass);
  }

  setIconUrls(): void {
    if (this.gender() === this.appConfig.Shared.Gender.MALE) {
      this.faceIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-male-face.svg";
      this.hairIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-male-hair.svg";
    } else {
      this.faceIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-female-face.svg";
      this.hairIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-female-hair.svg";
    }
  }
}
